export default __webpack_public_path__ + "images/pensatus-area-stone.svg";